<p-badge [value]="text" [severity]="type"></p-badge>
